import ShowIndexContent from 'show-index/containers/content';
import ShowIndexHeader from 'show-index/containers/header';
import styles from './styles.less';
import { debounce } from 'lodash';
import { observer } from 'mobx-react';


@observer
class SimulcastPage extends React.Component {
    constructor(props) {
        super(props);
        this.handleResize = debounce(this.handleResize.bind(this), 500);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize, false);
    }

    render() {
        return (
            <div className={ cx(styles.root, this.props.className) }>
                <ShowIndexHeader />
                <ShowIndexContent />
            </div>
        );
    }

    handleResize() {
        AMPTManager.refreshAllAds();
    }
}


export default SimulcastPage;



// WEBPACK FOOTER //
// ./src/show-index/containers/main/index.js